import { OrderProductGridItem } from '../../../../../orders/products/orderProducts.types';
import { getFakeProductItem } from '../../../../../products/products-details-v2/hooks/useCombination.utils';
import { CatalogSectionProductSize } from '../../../interfaces/catalogProductList.types';

interface BuildCatalogListDisplayedGridParams {
  sizes: CatalogSectionProductSize[];
  grid: OrderProductGridItem[];
}

export const buildCatalogListDisplayedGrid = ({
  sizes,
  grid,
}: BuildCatalogListDisplayedGridParams): OrderProductGridItem[] => {
  const gridBySizeId = new Map(grid.map((item) => [item.productSizeId, item]));

  return sizes.map((size) => {
    const gridItem = gridBySizeId.get(size.id);

    if (!gridItem) {
      return getFakeProductItem({ ...size, position: String(size.position) });
    }

    if (!size.productSizeActive) {
      return { ...gridItem, productSizeActive: false };
    }

    return gridItem;
  });
};
